"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _ScalewayObjectStoragePlugin = /*#__PURE__*/ _interop_require_default(require("./ScalewayObjectStoragePlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _ScalewayObjectStoragePlugin.default,
    id: 'scaleway',
    title: 'Scaleway',
    recoveryTitle: 'Scaleway Object Storage',
    version: '0.0.4',
    logo: 'plugins/scaleway.png',
    tags: 'Storage',
    description: 'Scaleway Object Storage is an S3-compatible object store from Scaleway Cloud Platform.',
    inputs: {
        title: 'Setup Scaleway',
        items: [
            {
                key: 'bucket',
                label: 'Bucket name',
                placeholder: 'Bucket name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'region',
                label: 'Region of bucket',
                placeholder: 'Region of bucket',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'acl',
                label: 'Access Control Lists (ACL)',
                placeholder: 'Default set to public-read',
                type: _nocodbsdk.XcType.SingleLineText,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in Scaleway Object Storage.',
        msgOnUninstall: ''
    },
    category: 'Storage'
};
const _default = config;
